import {DeliveryContainer, TextCard, TextLines,TextLine}  from "./content-delivery.style";
import {useEffect, useState} from "react";


// **  Text ** to have bold for title

const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
const API_KEY = process.env.REACT_APP_API_KEY;

const parseLine = (line) => {
    if (line.startsWith("**") && line.endsWith("**")) {
        return <h1 className="text-xl font-bold">{line.replace(/\*\*/g, "")}</h1>;
    }

    if (line.startsWith("- ")) {
        return <li>{line.slice(2)}</li>;
    }

    return line;
};

export const ContentDelivery = () => {


    const [sheetsData, setSheetsData] = useState([]);

    useEffect(() => {
        const fetchSecondSheetData = async () => {
            const metadataResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}?key=${API_KEY}`
            );

            const metadataResult = await metadataResponse.json();
            if (!metadataResult.sheets || metadataResult.sheets.length < 2) return;

            // 🔹 luăm DOAR pagina 2
            const secondSheetName = metadataResult.sheets[1].properties.title;

            const dataResponse = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${encodeURIComponent(
                    secondSheetName
                )}?key=${API_KEY}`
            );

            const data = await dataResponse.json();

            setSheetsData({
                sheetName: secondSheetName,
                headers: data.values?.[0] || [],
                rows: data.values?.slice(1) || [],
            });
        };

        fetchSecondSheetData();
    }, []);

    // prop boolean care ne spune dacă există date
    const hasData = sheetsData.rows && sheetsData.rows.length > 0;
    return (
        <DeliveryContainer hasData={hasData} id={"delivery"}>
            {hasData && (
                <TextCard hasData={hasData}>
                    <TextLines hasData={hasData}>
                        {sheetsData.rows.map((row, rowIndex) =>
                            (row[0] || "")
                                .split(/\r?\n/)
                                .filter(line => line.trim() !== "")
                                .map((line, i) => (
                                    <TextLine key={`${rowIndex}-${i}` } hasData={hasData}>{parseLine(line)}</TextLine>
                                ))
                        )}
                    </TextLines>
                </TextCard>
            )}
        </DeliveryContainer>
    )
}